import React from 'react';

import { FormattedMessage } from 'translations';
import classnames from 'classnames';
import LoadingScreen from 'app/components/base/LoadingScreen';
import { overwriteAirportDisplay } from 'app/utils/togglers';
import { HOURLY_MODE_VALUE } from 'app/constants';
import style from './style.css';


const messages = {
  pendingMessage: { id: 'SEARCH_RESULTS.PENDING_MESSAGE' },
  oneWay: { id: 'SEARCH_RESULTS.ONE_WAY' },
  roundtrip: { id: 'SEARCH_RESULTS.ROUNDTRIP' },
  fromTo: { id: 'SEARCH_RESULTS.PENDING_FROM_TO' }
};

export const SearchingLayout = ({
  className,
  startAddress,
  endAddress,
  mode,
  bookingMode,
  mobile,
  ...props
}) => {
  const contents = [(
    <span className={style.title} key="title">
      <FormattedMessage {...messages.pendingMessage} />
    </span>
  )];

  const isHourlySearch = bookingMode === HOURLY_MODE_VALUE;

  if (!isHourlySearch && startAddress && endAddress && mode) {
    const modeMessage = mode === 'one_way' ? messages.oneWay : messages.roundtrip;
    const values = {
      from: overwriteAirportDisplay(startAddress),
      to: overwriteAirportDisplay(endAddress)
    };
    contents.push(
      <span className={style.subtitle} key="subtitle">
        <FormattedMessage {...messages.fromTo} values={values} />
        &nbsp;
        (<FormattedMessage {...modeMessage} />)
      </span>
    );
  }

  const modifiers = {
    [style.mobile]: mobile
  };

  return (
    <LoadingScreen
      iconSize="large"
      className={classnames(className, style.container, modifiers)}
      {...props}
    >
      {contents}
    </LoadingScreen>
  );
};

// TODO: move to Flow types
// SearchingLayout.propTypes = {
//   className: PropTypes.string,
//   startAddress: PropTypes.object,
//   endAddress: PropTypes.object,
//   mode: PropTypes.string,
//   bookingMode: PropTypes.string,
//   mobile: PropTypes.bool
// };

export default SearchingLayout;
